import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=49f6c9c6&scoped=true"
import script from "./AuditLogs.ts?vue&type=script&lang=ts&external"
export * from "./AuditLogs.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6c9c6",
  null
  
)

export default component.exports